import './styles.scss';

export const HeroSection = () => {
  return (
    <section className='hero-section'>
      <div className='container hero-container'>
        <img
          className='hero-background mobile-only'
          src='hero-section/background-mobile.webp'
          alt='Green/Purple Particles'
          fetchPriority='high'
        />
        <img
          className='hero-particle hero-particle-1 desktop-only'
          src='hero-section/particle1-desktop.webp'
          alt='Green Particle'
        />
        <img
          className='hero-particle hero-particle-2 desktop-only'
          src='hero-section/particle2-desktop.webp'
          alt='Green Particle'
        />
        <div className='content'>
          <div className='text'>
            <h1 className='title'>
              <span className='title-white'>Your billboard called. </span>
              <br />
              <span className='title-green'>It's jealous.</span>
            </h1>
          </div>
          <div className='billboard'>
            <img src='billboard.webp' alt='The Big Sad Billboard' />
          </div>
        </div>
      </div>
    </section>
  );
};
